import VrrTooltip from './VrrTooltip';

export default VrrTooltip;
